module.exports = __webpack_public_path__ + "static/images/components/BuildingCardImage/images/arrow/arrow-4-50.c156f541.png";


//////////////////
// WEBPACK FOOTER
// ./components/BuildingCardImage/images/arrow/arrow-4-50.png
// module id = 2560
// module chunks = 11